// extracted by mini-css-extract-plugin
export default {"hero":"Foerderverein_hero__Sru7p","text":"Foerderverein_text__1ngep","darkBackground":"Foerderverein_darkBackground__JpGw1"};